module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAA0CAYAAAAnpACSAAAAAXNSR0IArs4c6QAAAPBJREFUaEPtmsENhDAMBE1l0NlBZ1AZd0aEAuIxOVkbiacn2R0+EUxmdhq3pk7U+jvHp3P2GfPNPUzvIaL7t/nFzPyJrPlfwkRCtNlVYYgaExgyk1AqgpQZpMYEiMwklIogZQapMQEiMwmlIkiZQWpMgNQzk1DSEORlpspaKoUZfvdH3wqZQesEYTIDlomiZAatE4TJDFgmipIZtE4Q5mb828h+PyD6fVT7CrDdod4/AbhjpTCnwoBvBomSGbJNkiUzZJskS2bINkmWzJBtkiyZIdskWTJDtkmyaprxm+YRrGn0bfUxE8xxjffeVrHfKr8QUFihCh90sgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page/crop/free.png
// module id = MVuM
// module chunks = 3